import SalesAgentIcon from "@mui/icons-material/Person";
import { useSelector } from "react-redux";
import { selectors as salesAgentsSelectors } from "../../redux/salesAgents";
import BaseTag from "./BaseTag";

const SaTag = (props) => {
  const entity = useSelector((state) =>
    salesAgentsSelectors.selectById(state, props.value),
  );
  const label = props.value === "__is_null" ? "No-Sales Agent" : entity?.name;
  return <BaseTag icon={<SalesAgentIcon />} label={label} />;
};

export default SaTag;
